<div id="campaignReport" style="display:none;margin-top: 3rem;">
    <app-header title=""></app-header>

    <div class="pt-4 container">
        <div class="row custom-material-form updated-dropdown">
            <div class="col">
                <div class="md-form">
                    <input placeholder="Start date" type="text" id="donStartDatePicker" class="form-control datepicker" style="cursor: pointer;">
                    <label id="donStartDatePickerLabel" for="donStartDatePicker">Start Date</label>
                    <i class="far fa-calendar-alt calendar-icon--paybee" onclick="document.getElementById('donStartDatePicker').focus()" style="cursor:pointer"></i>
                </div>
            </div>
            <div class="col">
                <div class="md-form">
                    <input placeholder="End date" type="text" id="donEndDatePicker" class="form-control datepicker" >
                    <label id="donEndDatePickerLabel" for="donEndDatePicker">End Date</label>
                    <i class="far fa-calendar-alt calendar-icon--paybee" onclick="document.getElementById('donEndDatePicker').focus()" style="cursor:pointer"></i>
                </div>
            </div>
        </div>
        <div class="row" id="allCampaignsReport" style="display:none">
            <table class="table">
                <tbody id="allCampaignsReportTable">
                </tbody>
            </table>
        </div>
        <div id="campaignDetailsReport" class="row" style="display:none">
            <div id="campaignDetailsReportPage"></div>
        </div>
    </div>
</div>